import { actions } from './moving/actions'
import { getters } from './moving/getters'
import { state } from './moving/state'
import { mutations } from './moving/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
